import { envConfig } from '../../../env';
import { localStg } from '@/utils/storage/local';
import {
    EnumContentType,
    EnumDefaultResponseResult,
    EnumDocRequest,
    EnumLocalStore,
    EnumNetworkErrMap
} from '@/constant/enums';
import qs from 'qs';
import { isFile } from '@/utils/typeof';
import { message } from '@/utils/message';
import router from '../../router';

/**
 * 处理请求头
 * @param config
 * @returns {*}
 */
export async function transformRequestData (config, requestData) {
    const contentType = config.headers['Content-Type'];
    if (contentType == EnumContentType.json) {

    } else if (contentType == EnumContentType.formData) {
        requestData = await handleFormData(requestData)
    } else if (contentType == EnumContentType.formUrlencoded) {
        requestData = qs.stringify(requestData);
    }
    return requestData;
};

/**
 * 鉴权处理
 * @param config
 * @returns {*}
 */
export async function handleConfigureAuth(config) {
    // 如果本地存储中有token，则添加到请求头中
    if (localStg.get(EnumLocalStore.jwtTokenName)) {
        config.headers[EnumLocalStore.authorizationHeaderName] = localStg.get(EnumLocalStore.jwtTokenName);
    }
    return config;
}

export async function handleFailRequest(status, msg, response) {
    let networkResult = await handleNetworkError(status, msg)
    if (networkResult) {
        return networkResult
    }
    let responseData = response.data
    if (responseData) {
        message.error(responseData.message)
        // if (responseData.code && responseData.code === 702) {
        //     localStg.clear()
        //     setTimeout(() => {
        //         location.reload()
        //     }, 1000)
        // }
    }else {
        if (status && EnumNetworkErrMap[status]) {
            message.error(EnumNetworkErrMap[status])
        }
    }
    let failResult = EnumDefaultResponseResult
    if (response && response.data) {
        failResult.code = response.data.code
        failResult.message = response.data.message
    }
    return failResult
}

/**
 * 处理网络异常
 * @param errStatus
 */
export async function handleNetworkError(errStatus, msg) {
    let data = {
        code: null,
        message: null
    }
    if (!window.navigator.onLine || msg && msg.indexOf('Network Error') !== -1) {
        message.error('网络错误')
        data.code = null
        data.message = "网络错误"
        return data
    }
    if (msg && msg && msg.indexOf('timeout of') !== -1) {
        message.error('请求超时')
        data.code = null
        data.message = "请求超时"

        return data
    }
    return undefined
}

/**
 * 处理认证错误
 * @param errno
 * @returns {boolean}
 */
export const handleAuthError = (code) => {
    // if (authErrMap.hasOwnProperty(code)) {
    //     message.error(authErrMap[code]);
    //     // 授权错误，登出账户
    //     // logout();
    //     return false;
    // }

    return true;
};

export const handleRefreshToken = (axiosConfig) => {
    message.error("身份验证已过期，请重新登录！")
    localStg.clear()
    router.push('/login')
};

export function handleDocRequest(axiosConfig) {
    let requestUrl = axiosConfig.config.url
    if (requestUrl.indexOf(EnumDocRequest.docApi) !== -1 || requestUrl.indexOf(EnumDocRequest.resource) !== -1) {
        let data = axiosConfig.data
        axiosConfig.data = {
            code: 200,
            message: '文档请求成功',
            data: data
        }
    }
    return axiosConfig;
}

/**
 * 根据环境获取baseUrl
 */
export const getBaseUrl = () => {
    const currentEnv = process.env.NODE_ENV;
    let baseUrl = envConfig[currentEnv];
    if (!baseUrl.endsWith('/')) {
        baseUrl = baseUrl + '/';
    }
    return baseUrl;
};

export const getCorrectRequestUrl = (requestUri) => {
    let baseUrl = getBaseUrl();
    if (requestUri.startsWith('/')) {
        requestUri = requestUri.substring(1, requestUri.length);
    }
    return baseUrl + requestUri;
};

async function transformFile(formData, key, file) {
    if (Array.isArray(file)) {
        // 多文件
        await Promise.all(
            file.map((item) => {
                formData.append(key, item);
                return true;
            })
        );
    }else {
        // 单文件
        formData.append(key, file);
    }
}

async function handleFormData(data) {
    const formData = new FormData();
    const entries = Object.entries(data);

    for(const [key, value] of entries) {
        const isFileType =
            isFile(value) || (Array.isArray(value) && value.length && isFile(value[0]));
        if(isFileType) {
            await transformFile(formData, key, value);
        }else {
            formData.append(key, value);
        }
    }
    return formData;
}